export default __webpack_public_path__ + "static/media/10-Nature_thumb.666769b8.jpg";